import { useSelector } from 'react-redux'

import { IWidgetProps } from 'core-components/sitebuilder/models/IWidgetProps'
import { selectAppOwnerId } from 'core-components/sitebuilder/store/selectors/selectAppOwnerId'

import styles from './EmptyWidget.module.scss'

interface IEmptyWidget extends IWidgetProps {
  name: string
}

export const EmptyWidget = ({ name }: IEmptyWidget) => {
  const ownerId = useSelector(selectAppOwnerId)
  const isProductionBuild = ownerId.includes('-prod')
  const errorText = `React widget with ViewModel ${name} is not found`
  // useMeasureController(metrics, { dataLoaded: true })

  if (isProductionBuild) {
    console.error(errorText)
    return <></>
  }

  return <div className={styles.root}>{errorText}</div>
}
export default EmptyWidget
